import GraphicStorageTableHelper from './graphic-storage-table-helper';
import GraphicStorageStandsTableHelper from './graphic-storage-stands-table-helper';


const GraphicStorageHelpers = {
    TableMain: GraphicStorageTableHelper,
    TableStands: GraphicStorageStandsTableHelper,
}

export default GraphicStorageHelpers;
